module.exports = __webpack_public_path__ + "img/25-Chêne des Marais.jpg";